import React, { useState, useEffect } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import {
  Form,
  Skeleton,
  Row,
  Col,
  Input,
  Space,
  Button,
  Divider,
  message,
  InputNumber,
  Drawer,
} from "antd";
import ContractTemplateEditor from "@general/contractTemplateEditor";
function AdminSettings(props) {
  const [form] = Form.useForm();
  const GETSETTINGFORM = gql`
    {
      getCardContractVariable{
        name
        title
      }
      getHolidayContractVariable{
        name
        title
      }
      getSettingForm {
        farazsmsUser
        farazsmsPass
        farazsmsFromNum
        farazsmsPatternResetOtp
        farazsmsPatternRegisterOtp
        farazsmsPatternRemider1
        farazsmsPatternRemider2
        farazsmsPatternNewMessage
        bpmTerminalId
        bpmUserName
        bpmUserPassword
        cardAmount
        cardContract
        holidayAmount
        holidayContract
      }
    }
  `;

  const UPDATESETTING = gql`
    mutation updateSettingForm($settingFormInput: SettingFormInput!) {
      updateSettingForm(updateInput: $settingFormInput)
    }
  `;

  const [formData, setFormData] = useState({});
  const [holidayContractDrawer, setHolidayDrawer] = useState(false);
  const [cardContractDrawer, setCardDrawer] = useState(false);
  const [holidayContract, setHolidayContract] = useState("<html></html>");
  const [cardContract, setCardContract] = useState("<html></html>");
  const [cardContractVariables, setCardContractVariable] = useState();
  const [holidayContractVariables, setHolidayContractVariable] = useState();
  const [getSettingForm, settingForm] = useLazyQuery(GETSETTINGFORM, {
    onCompleted({ getSettingForm, getHolidayContractVariable, getCardContractVariable}) {
      setFormData(getSettingForm);
      setHolidayContract(getSettingForm?.holidayContract);
      setCardContract(getSettingForm?.cardContract);
      setCardContractVariable(getCardContractVariable);
      setHolidayContractVariable(getHolidayContractVariable);
    },
    onError(err) {
      console.log("خطا: " + err.message);
    },
  });
  const [runUpdateSettingForm, updateSettingForm] = useMutation(UPDATESETTING, {
    onCompleted() {
      message.success("تنظیمات بروزرسانی شد.");
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! تنظیمات بروزرسانی نشد.");
    },
  });

  const openHolidayContractDrawer = () => {
    setHolidayDrawer(true);
    setCardDrawer(false);
  };
  const closeHolidayContractDrawer = () => {
    setHolidayDrawer(false);
  };
  const openCardContractDrawer = () => {
    setCardDrawer(true);
    setHolidayDrawer(false);
  };
  const closeCardContractDrawer = () => {
    setCardDrawer(false);
  };
  useEffect(() => {
    getSettingForm();
    form.setFieldsValue(formData);
  }, [formData]);
  const doUpdateSetting = (settingFormInput) => {
    runUpdateSettingForm({
      variables: {
        settingFormInput: {
          ...settingFormInput,
          cardAmount: settingFormInput.cardAmount.toString(),
          holidayAmount: settingFormInput.holidayAmount.toString(),
          holidayContract,
          cardContract,
        },
      },
    });
  
  };

  if (settingForm.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  else if (formData)
    return (
      <>
        <Drawer
          title={"تعهدنامه استفاده از روز تعطیل"}
          placement="top"
          open={holidayContractDrawer}
          onClose={closeHolidayContractDrawer}
          height={550}
        >
          <ContractTemplateEditor
            contract={holidayContract}
            onCloseDrawer={closeHolidayContractDrawer}
            onEditContract={(newContract) => setHolidayContract(newContract)}
            helpVars={holidayContractVariables}
          />
        </Drawer>
        <Drawer
          title={"تعهدنامه کارت"}
          placement="top"
          open={cardContractDrawer}
          onClose={closeCardContractDrawer}
          height={550}
        >
          <ContractTemplateEditor
            contract={cardContract}
            onCloseDrawer={closeCardContractDrawer}
            onEditContract={(newContract) => setCardContract(newContract)}
            helpVars={cardContractVariables}
          />
        </Drawer>
        <Form layout="vertical" form={form} onFinish={doUpdateSetting}>
          <Row gutter={30}>
            <Col xs={24} md={12}>
              <Divider orientation="right">
                <h4 style={{ fontWeight: 600 }}>درگاه اس ام اس - faraz sms</h4>
              </Divider>
              <Row gutter={15}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsUser"
                    id="farazsmsUser"
                    label="نام کاربری"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفا نام کاربری را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={" نام کاربری"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsPass"
                    id="farazsmsPass"
                    label="رمز عبور"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفا رمز عبور را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input.Password
                      className="form-input"
                      placeholder={"رمز عبور"}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={15}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsFromNum"
                    id="farazsmsFromNum"
                    label="شماره ارسال کننده"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "لطفا شماره ارسال کننده را وارد کنید!",
                      // },
                      {
                        pattern: /^[0-9]*$/,
                        message:
                          "لطفا شماره ارسال کننده را به طور صحیح وارد کنید",
                      },
                    ]}
                  >
                    <Input className="form-input" placeholder={"شناسه"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsPatternResetOtp"
                    id="farazsmsPatternResetOtp"
                    label="الگوی فراموشی رمز عبور"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفاالگو را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={"الگو"} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={15}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsPatternRegisterOtp"
                    id="farazsmsPatternRegisterOtp"
                    label="الگوی کد ثبت نام"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفا الگو را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={"الگو"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="farazsmsPatternRemider1"
                    id="farazsmsPatternRemider1"
                    label="الگوی یادآور اول"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفاالگو را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={"الگو"} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={15}>
                <Col xs={24} sm={12}>
  
                  <Form.Item
                    name="farazsmsPatternRemider2"
                    id="farazsmsPatternRemider2"
                    label="الگوی یادآور دوم"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفاالگو را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={"الگو"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
  
                  <Form.Item
                    name="farazsmsPatternNewMessage"
                    id="farazsmsPatternNewMessage"
                    label="الگوی پیام جدید"
                    rules={
                      [
                        // {
                        //   required: true,
                        //   message: "لطفاالگو را وارد کنید!",
                        // },
                      ]
                    }
                  >
                    <Input className="form-input" placeholder={"الگو"} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col xs={24} md={12}>
              <Divider orientation="right">
                <h4 style={{ fontWeight: 600 }}>کارت عضویت</h4>
              </Divider>
              <Row>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="cardAmount"
                    id="cardAmount"
                    label="هزینه کارت (ریال)"
                    rules={[
                      {
                        required: true,
                        message: "لطفا هزینه کارت را وارد کنید!",
                      },
                      {
                        pattern: /^[0-9]*$/,
                        message: "لطفا هزینه کارت را به طور صحیح وارد کنید",
                      },
                    ]}
                  >
                    <InputNumber
                      formatter={(value) =>
                        value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                      }
                      parser={(value) =>
                        value?.replace(/\$\s?|(,*)/g, "") || ""
                      }
                      className="form-input"
                      placeholder={"هزینه کارت"}
                      style={{ textAlign: "left", width: "100%" }}
                    />
                  </Form.Item>
                  <Button onClick={openCardContractDrawer} type="primary">
                    تعهدنامه کارت
                  </Button>
                </Col>
              </Row>
              <Divider orientation="right">
                <h4 style={{ fontWeight: 600 }}>روزهای تعطیل</h4>
              </Divider>
              <Row gutter={15}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="holidayAmount"
                    id="holidayAmount"
                    label="هزینه روز تعطیل (ریال)"
                    rules={[
                      {
                        required: true,
                        message: "لطفا هزینه را وارد کنید!",
                      },
                      {
                        pattern: /^[0-9]*$/,
                        message: "لطفا هزینه را به طور صحیح وارد کنید",
                      },
                    ]}
                  >
                    <InputNumber
                      formatter={(value) =>
                        value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                      }
                      parser={(value) =>
                        value?.replace(/\$\s?|(,*)/g, "") || ""
                      }
                      className="form-input"
                      placeholder={"هزینه استفاده"}
                      style={{ textAlign: "left", width: "100%" }}
                    />
                  </Form.Item>
                  <Button onClick={openHolidayContractDrawer} type="primary">
                    تعهدنامه روز تعطیل
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider orientation="right">
            <h4 style={{ fontWeight: 600 }}>Beh pardakht بانک ملت</h4>
          </Divider>
          <Row gutter={15}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name="bpmUserName"
                id="bpmUserName"
                label="نام کاربری"
                rules={[
                  {
                    required: true,
                    message: "لطفا نام کاربری را وارد کنید!",
                  },
                ]}
              >
                <Input className="form-input" placeholder={" نام کاربری"} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name="bpmUserPassword"
                id="bpmUserPassword"
                label="رمز عبور"
                rules={[
                  {
                    required: true,
                    message: "لطفا رمز عبور را وارد کنید!",
                  },
                ]}
              >
                <Input.Password
                  className="form-input"
                  placeholder={"رمز عبور"}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item
                name="bpmTerminalId"
                id="bpmTerminalId"
                label="شناسه ترمینال"
                rules={[
                  {
                    required: true,
                    message: "لطفا شناسه را وارد کنید!",
                  },
                ]}
              >
                <Input className="form-input" placeholder={"شناسه"} />
              </Form.Item>
            </Col>
          </Row>
          <Space style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={updateSettingForm.loading && true}
            >
              بروزرسانی
            </Button>
          </Space>
        </Form>
      </>
    );
}

export default AdminSettings;
